 
import React from "react";
import { motion } from "framer-motion";

function Features() {
  const features = [
    {
      title: "Data Pipelines",
      description:
        "We build reliable and scalable data pipelines to process and deliver accurate data to support analytics.",
      color: "#1E90FF",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "ETL Solutions",
      description:
        "Our ETL (Extract, Transform, Load) solutions streamline data ingestion and transformation for better analytics.",
      color: "#0077B6",
      animation: { x: 100, y: 0 }, // from right
    },
    {
      title: "Data Warehousing",
      description:
        "We design and implement data warehouses that consolidate data from multiple sources into a unified structure for easy access and analysis.",
      color: "#00A7C4",
      animation: { x: 0, y: 100 }, // from bottom
    },
    {
      title: "Advanced Analytics",
      description:
        "We apply advanced analytics techniques, including machine learning and AI, to generate insights from complex datasets.",
      color: "#3FA34D",
      animation: { x: 0, y: -100 }, // from top
    },
    {
      title: "Data Visualization",
      description:
        "We create interactive dashboards and reports to help businesses visualize and interpret data effectively.",
      color: "#FF9800",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Cloud Integration",
      description:
        "Our cloud-based solutions integrate seamlessly with your existing infrastructure, enabling scalability and cost-efficiency.",
      color: "#9C27B0",
      animation: { x: 100, y: 0 }, // from right
    },
  ];

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "#f8f9fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "28px",
      marginBottom: "30px",
      fontWeight: "bold",
      letterSpacing: "0px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      padding: "20px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "200px",
      cursor: "pointer",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#4b5563",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Enhancing Business Decisions with Data</h2>
      <div style={styles.grid}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={feature.animation}
            whileInView={{ x: 0, y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderLeft = `16px solid ${feature.color}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderLeft = `8px solid ${feature.color}`;
            }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Features;
